var res = [{"key":"Uk Power Networks average","value":"£78.99"},{"key":"2nd lowest DNO group average","value":"£87.01"},{"key":"Industry average","value":"£91.73"},{"key":"Most expensive DNO group average","value":"£101.09"}];res.columns = ["key","value"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/domestic-charges.csv
// module id = 610
// module chunks = 0